/**
 * 生成基础axios对象，并对请求和响应做处理
 * 前后端约定接口返回解构规范
 * {
 *    code:200,
 *    data:"",
 *    message:""
 * }
 */
import axios from 'axios' // 引入 axios 网络请求库

// 创建一个独立的axios实例
// 说明：
// 1. 登录验证码依赖 PHP Session（think_captcha），同一个 Session 才能通过校验
// 2. 前端验证码图片使用的是 `${import.meta.env.VITE_BASE_API}/customer/user/verify.html`
// 3. 如果这里 baseURL 还是空字符串，在开发或正式环境只要「前端域名」和「接口域名」不同，
//    验证码图片请求走 VITE_BASE_API，而登录接口走当前页面域名，Session 就会分裂成两份，
//    导致第一次登录必然出现“验证码错误”，第二次刷新后才会成功。
// 4. 因此必须把 axios 的 baseURL 固定为 VITE_BASE_API，保证验证码图片和登录接口完全同源。
const service = axios.create({
  baseURL: import.meta.env.VITE_BASE_API || '', // 后端API基础URL，优先使用环境变量
  // headers: {},// 可在此统一定义请求头部
  withCredentials: true, // 开启跨域携带Cookie，确保验证码和登录使用同一个session
  timeout: 60000 // 请求超时时间改为60秒
})

// token 请求白名单,请求后台时不需要传token的接口地址（目前暂未使用，仅保留注释）
// const writeList = ['/customer/login']

// 请求拦截
service.interceptors.request.use(
  config => {
    // 在发送请求之前做统一处理（目前暂不额外处理，直接返回配置）
    return config
  },
  error => {
    // 处理请求错误，统一返回 Promise.reject 交给调用方
    return Promise.reject(error)
  }
)

// 这里暂不使用统一的响应拦截逻辑，由 /axios/request.js 统一处理业务 code
export default service
